<template>
    <div class="budgets-hero">
        <Container class="md:py-8 flex flex-col py-6">
            <div class="max-w-3xl mx-auto my-2 text-center text-white">
                <h1 class="lg:text-2xl max-w-2xl mx-auto mt-0 mb-4 text-xl font-normal tracking-tighter">
                    {{ $t('budgets_landing_page.cta_section_title') }}
                </h1>
                <p class="text-base font-normal leading-tight text-blue-100">
                    {{ $t('budgets_landing_page.cta_section_text') }}
                </p>
                <div class="flex items-center justify-center mt-10 space-x-6">
                    <a class="focus:no-underline group hover:no-underline hover:text-blue-200 text-blue-50 lg:border-transparent border-blue-50 inline-flex items-center px-4 py-2 text-base font-medium bg-transparent border rounded cursor-pointer"
                        href="/schedule-a-call"
                        id="schedule-a-call-hero-link">
                        <span class="bg-blue-50 group-hover:bg-blue-100 text-2xs inline-flex items-center justify-center w-5 h-5 mr-2 rounded-full">
                            <span class="icon icon-video-camera text-blue-500"></span>
                        </span>
                        {{ $t('budgets_landing_page.schedule_a_call_cta') }}
                    </a>
                    <a class="focus:no-underline hover:border-blue-100 hover:bg-blue-100 hover:no-underline hover:shadow-lg lg:px-12 bg-blue-50 border-blue-50 inline-block px-4 py-2 text-base font-medium text-blue-500 border rounded cursor-pointer"
                        href="/sign-up"
                        id="sign-up-hero-link">
                        {{ $t('budgets_landing_page.sign_up_cta') }}
                    </a>
                </div>
            </div>
        </Container>
    </div>
</template>

<script>
import Container from '../../../../shared/container.vue';

export default {
    components: {
        Container,
    },
};
</script>
